// js-calculate-with-discount.js
;(({ $, $$ , log}) => {
    $$('.js-calculate-with-discount').forEach(tool => {
        const input = tool.querySelector('.js-calculate-with-discount__input')
        const output = tool.querySelector('.js-calculate-with-discount__output')

        if (!input || !output) { return }

        const discountMapStr = tool.dataset.discountMap
        let discounts = []

        init()

        function init() {
            discounts = parseDiscount(discountMapStr)

            input.addEventListener('input', event => {
                const value = parseFloat(event.target.value) || 0
                
                calcAndUpdate(value)
            })

            calcAndUpdate(parseFloat(input.value) || 0)
        }

        function calcAndUpdate(value) {
            let discount = 0

            for (let i = discounts.length - 1; i >= 0; --i) {
                const pair = discounts[i]
                
                if (value >= pair.sum) {
                    discount = pair.discount
                    break
                }
            }

            output.value = (value - value * discount).toFixed(2)
        }
    })

    function parseDiscount(str) {
        if (!str) { return [] }
        return str.split('|').map(pair => {
            const temp = pair.split('-')
            return { 
                sum: parseFloat(temp[0]), 
                discount: parseFloat(temp[1]) / 100
            }
        })
    }
})(CNS);